<template>
    <LinksCss :links="[
        getWithHost(tailwindCss),
        getWithHost(flicking),
        getWithHost(flickingInline),
        getWithHost(flickingArrow)
    ]" v-model:onLoadEnd="show">
    </LinksCss>

    <body v-if="show">
        <BookCarouselFlickingVue 
        :props="bookCarouselItems" 
        :loading="basketStore.loading"
        @to_basket="basketStore.addBasketProduct($event.id)">
        </BookCarouselFlickingVue>
    </body>
</template>
<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useBasketStore } from '@/stores/basket'
import type { BasicCarouselProps } from '@/types/book_item'
import { getWithHost } from '@/utils/utils'
import BookCarouselFlickingVue from '@/components/BookCarouselFlicking.vue'
import tailwindCss from '@/styles/style.css?url'
import LinksCss from '@/components/LinksCss.vue'
import flicking from '@egjs/vue3-flicking/dist/flicking.css?url'
import flickingInline from '@egjs/vue3-flicking/dist/flicking-inline.css?url'
import flickingArrow from "@egjs/flicking-plugins/dist/arrow.css?url";

const props = defineProps<{
    props: string
}>()

const basketStore = useBasketStore()
const bookCarouselItems = computed((): BasicCarouselProps => {
    const propsParsed = JSON.parse(props.props) as BasicCarouselProps | undefined
    if (!propsParsed) {
        return {
            label: '',
            items: []
        }
    }
    return {
        label: propsParsed.label,
        items: propsParsed.items.map((v) => {
            const basketItem = basketStore.items.find(el => el.product_id == v.id)
            // find(basketStore.items, ['product_id', v.id])
            if (!basketItem) {
                return v
            }
            return { ...v, in_bascet: true }
        })
    }
})

const show = ref(false)

</script>